module.exports = __webpack_public_path__ + "static/media/girl-computer.97460664.jpg";